import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { startSubmit, stopSubmit } from 'redux-form';

import * as actionTypes from './action-types';
import * as actions from './actions';
import * as api from 'api/config/interests';
import callApi from 'store/api/saga';

import * as flashActions from 'store/features/common/flash/actions';
import { messageTypes } from 'store/features/common/flash/builder';
import * as messages from 'ui/signup-wizard/interests/messages';

import * as wizardActions from 'store/features/wizard/actions';

function* setInterests({ payload, meta }) {
  const { values, userId } = payload;
  const { form, wizard } = meta;

  yield put(actions.setInterests.start(values));
  if (form) yield put(startSubmit(form));

  try {
    const response = yield call(callApi, api.setInterests(values, userId));

    yield put(actions.setInterests.success(response));
    if (!wizard) {
      yield put(
        flashActions.addMessage({
          id: `interest.messages.success`,
          kind: messageTypes.success,
          content: messages.responses.interestsSuccess,
          dismissable: true,
        })
      );
    }

    if (form) yield put(stopSubmit(form));
    if (wizard) {
      const { name, stepCompleteApiConfig: apiConfig } = wizard;
      yield put(wizardActions.completeStep.request({ name, apiConfig }));
    }
  } catch (error) {
    yield put(actions.setInterests.failure(error));

    yield put(
      flashActions.addMessage({
        id: `interest.messages.error`,
        kind: messageTypes.danger,
        content: error.message || messages.responses.interestsError,
      })
    );
    if (form) yield put(stopSubmit(form, error.formErrors));
  }
}

function* watchSetInterests() {
  yield takeEvery(actionTypes.SET_USER_INTERESTS.REQUEST, setInterests);
}

export default function* votes() {
  yield fork(watchSetInterests);
}



// WEBPACK FOOTER //
// ./src/store/features/interests/saga.js